module.exports = __webpack_public_path__ + "static/media/important-notice.0f1b8629.svg";